import React, { Component } from 'react';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
// our components
import { Mutation } from 'components/common/Query';
import SendEmail from './SendEmail';

export const SEND_EMAIL_MUTATION = gql`
  mutation sendEmail($email: String!, $context: String!, $template: String!) {
    sendEmail(
      input: { email: $email, context: $context, template: $template }
    ) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

class SendEmailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      errors: [],
    };
    this.Compose = adopt({
      mutateSendEmail: this.SendEmailMutation,
    });
  }

  SendEmailCompleted = ({ sendEmail: { errors } }) => {
    if (errors) {
      this.setState({ errors, success: false });
    } else {
      this.setState({ errors: [], success: true });
    }
  };

  SendEmailMutation = ({ render }) => (
    <Mutation
      mutation={SEND_EMAIL_MUTATION}
      onCompleted={this.SendEmailCompleted}
    >
      {handleSendEmailMutation => render({ handleSendEmailMutation })}
    </Mutation>
  );

  /**
   * @description
   * Render PermissionList component.
   * @returns {*} PermissionList component.
   */
  render() {
    const { errors, success } = this.state;
    return (
      <this.Compose>
        {({ mutateSendEmail: { handleSendEmailMutation } }) => (
          <SendEmail
            errors={errors}
            success={success}
            closeNotification={() =>
              this.setState({ errors: [], success: false })
            }
            sendEmail={variables => handleSendEmailMutation({ variables })}
          />
        )}
      </this.Compose>
    );
  }
}

export default SendEmailContainer;
